import { Buttons, Controller } from "./controls/controller";
import { preStartContext } from "./controls/contexts/pre-start.context";
import { MenuManager } from "./menus/menu-manager";
import { getPreStartMenu } from "./menus/pre-start.menu";
import { GameState } from "./state/game-state";
import { preStartMenuContext } from "./controls/contexts/pre-start-menu.context";
import { ControllerContextKey } from "./controls/contexts/contextKeys";
import { MenuKeys } from "./menus/menu-keys";
import { networkGameplayContext } from "./controls/contexts/network-gameplay-menu.context";
import { onlineGameplayMenuContext } from "./controls/contexts/online-gameplay-menu.context";
import { getOnlineGameplayMenu } from "./menus/online-gameplay.menu";

type InitProps = {
  gameContainerId: string;
  mapId: string;
  playerLayerId: string;
  upButtonId: string;
  downButtonId: string;
  leftButtonId: string;
  rightButtonId: string;
  actionAButtonId: string;
  actionBButtonId: string;
  metaSelectButtonId: string;
  metaStartButtonId: string;
  menuContainerId: string;
};

function initializeGame(props: InitProps): void {
  const gameContainer = document.getElementById(
    props.gameContainerId,
  ) as HTMLDivElement | null;
  const map = document.getElementById(props.mapId) as HTMLDivElement | null;
  const playerLayer = document.getElementById(
    props.playerLayerId,
  ) as HTMLDivElement | null;
  const menuContainer = document.getElementById(
    props.menuContainerId,
  ) as HTMLDivElement | null;

  if (!gameContainer || !map || !playerLayer || !menuContainer) {
    console.warn("Critical container not found.");
    return;
  }

  // No local player at start; wait for Go Online -> WS -> server broadcast
  const gameState = new GameState(map, playerLayer);

  const buttons = {
    start: document.getElementById(props.metaStartButtonId),
    select: document.getElementById(props.metaSelectButtonId),
    up: document.getElementById(props.upButtonId),
    down: document.getElementById(props.downButtonId),
    left: document.getElementById(props.leftButtonId),
    right: document.getElementById(props.rightButtonId),
    actionA: document.getElementById(props.actionAButtonId),
    actionB: document.getElementById(props.actionBButtonId),
  } as unknown as Buttons;

  if (
    Object.values({
      start: buttons.start,
      select: buttons.select,
      up: buttons.up,
      down: buttons.down,
      left: buttons.left,
      right: buttons.right,
      actionA: buttons.actionA,
      actionB: buttons.actionB,
    }).some((el) => !el)
  ) {
    console.warn("One or more buttons not found.");
    return;
  }

  const menuManager = new MenuManager([
    {
      name: MenuKeys.PreStartMenu,
      menu: getPreStartMenu(menuContainer, gameState),
    },
    {
      name: MenuKeys.OnlineGameplayMenu,
      menu: getOnlineGameplayMenu(menuContainer, gameState),
    },
  ]);

  const controller = new Controller(
    {
      gameState,
      menuManager,
    },
    buttons,
    {
      [ControllerContextKey.PreStart]: preStartContext,
      [ControllerContextKey.PreStartMenu]: preStartMenuContext,
      [ControllerContextKey.NetworkGameplay]: networkGameplayContext,
      [ControllerContextKey.OnlineGameplayMenu]: onlineGameplayMenuContext,
    },
  );

  // Start in PreStart context; user can open menu and choose "Go Online"
  controller.pushContext(ControllerContextKey.PreStart);
}

window.addEventListener("DOMContentLoaded", () => {
  initializeGame({
    gameContainerId: "game-container",
    mapId: "game-map",
    playerLayerId: "game-players",
    upButtonId: "pad-up",
    downButtonId: "pad-down",
    leftButtonId: "pad-left",
    rightButtonId: "pad-right",
    actionAButtonId: "button-a",
    actionBButtonId: "button-b",
    metaSelectButtonId: "select",
    metaStartButtonId: "start",
    menuContainerId: "game-container",
  });
});
